module.exports = __webpack_public_path__ + "static/media/bioIcon.9a72627c.svg";